import { toTitleCase } from '../../../../../utils';

const convertToFloat = (value) => parseFloat(value || 0);

export const parseDropoffAmount = (dropoff, silo) => {
    if (dropoff.split_details?.length && silo) {
        const split = dropoff.split_details.find((s) => s.silo === silo);
        return convertToFloat(split?.amount);
    }
    return convertToFloat(dropoff.volume) ?? convertToFloat(dropoff.net_weight);
};

export const sumDropoffAmounts = (dropoffs, silo_id) => dropoffs.reduce((acc, dropoff) => acc + parseDropoffAmount(dropoff, silo_id), 0);

export const calculateInvoiceTotal = ({ dropoffs, inProgressDropoffs, previous_silo_invoice, silo_id, carry_over }) => {
    const allDropoffs = [...(!!dropoffs ? dropoffs : []), ...(!!inProgressDropoffs ? inProgressDropoffs : [])];
    const silo = silo_id?.id ?? silo_id?._id ?? silo_id;
    const amount = sumDropoffAmounts(allDropoffs, silo) + convertToFloat(previous_silo_invoice?.carry_over) - convertToFloat(carry_over);
    return amount;
};

export const columns = [
    {
        field: 'invoice_number',
        headerName: 'Invoice Number',
        flex: 0.5,
        type: 'number',
    },
    {
        field: 'silo_number',
        headerName: 'Silo Number',
        flex: 0.5,
        type: 'number',
        valueGetter: ({ row }) => row.silo_id?.silo_number,
    },
    {
        field: 'number_of_loads',
        headerName: '# Loads',
        flex: 0.5,
        type: 'number',
        valueGetter: ({ row }) => [...row.dropoffs, ...row.inProgressDropoffs]?.length,
    },
    {
        field: 'amount',
        headerName: 'Amount (lbs)',
        flex: 1,
        type: 'number',
        valueGetter: ({ row }) => calculateInvoiceTotal(row),
        valueFormatter: ({ value }) => (!!value ? value.toLocaleString() : ''),
    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1,
        valueFormatter: ({ value }) => (!!value ? toTitleCase(value) : ''),
    },
    {
        field: 'created_at',
        headerName: 'Created At',
        flex: 1,
        type: 'dateTime',
        valueFormatter: ({ value }) => (!!value ? new Date(value).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' }) : ''),
    },
    {
        field: 'closed_at',
        headerName: 'Closed At',
        flex: 1,
        type: 'dateTime',
        valueFormatter: ({ value }) => (!!value ? new Date(value).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' }) : ''),
    },
];

export default columns;
